import { FunctionComponent } from 'react';
import classnames from 'classnames';

import Button, { ButtonTypes } from 'components/layout/Button';
import Form from 'components/layout/forms/Form';
import Input from 'components/layout/forms/Input';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutFormsFaqForm: FunctionComponent<Props> = ({
    buttonProps,
    onSuccess,
    input,
    title,
    initialValues,
}) => {
    return (
        <StyledComponent
            className={classnames(
                'public-layout-faq-search-form',
            )}
        >
            {title && (
                <h1 className='form-title'>{title}</h1>
            )}
            <Form
                initialValues={initialValues}
                submitAction={async (values) => {
                    try {
                        const response = true;
                        response && onSuccess(values.search);
                    } catch (error) {
                        console.error(error);
                        return null;
                    }
                }}
                onSuccess={onSuccess}
            >
                {({ formik }) => {
                    return (
                        <>
                            <div className="form-inputs">
                                <Input
                                    name="search"
                                    type="text"
                                    label={input?.label}
                                    placeholder={input?.placeholder}
                                    onChange={formik.handleChange}
                                    value={formik.values.search}
                                />
                                <Button
                                    {...buttonProps}
                                    loading={formik.isSubmitting}
                                    type={ButtonTypes.Submit}
                                />
                            </div>
                        </>
                    );
                }}
            </Form>
            {/* <div className="button-wrapper">
                <Button
                    {...categoryProps}
                >
                    {button.label1}
                </Button>
                <Button
                    {...categoryProps}
                >
                    {button.label2}
                </Button>
                <Button
                    {...categoryProps}
                >
                    {button.label3}
                </Button>
                <Button
                    {...categoryProps}
                >
                    {button.label4}
                </Button>
            </div> */}
        </StyledComponent>
    );
};

export default PublicLayoutFormsFaqForm;